<template>
  <router-view />
  <metainfo /> 
</template>

<script>
export default {
  name: 'App'
};
</script>